import { Image, Button, Form, FormControl } from "react-bootstrap";
import Search_icon from "../../../../assests/images/search-icon.svg";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import { UniversalSearchProps } from "../../../../utils/types";
import { useEffect, useState } from "react";
import AutosuggestSearch from "../../../common/autoSuggestSearch";
import { InputGroupIcon } from "../../headerStyle";
const SearchHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchVal, setSearchVal] = useState('')


    const [zipCodeVal, setZipCodeVal] = useState('')
    const [locationSlug, setLocationSlug] = useState('');



    let searchQueryValue = "";
    const pathname = location.pathname;

    const pattern = /\/search:([^/]+)|\/sort:([^/]+)|\/direction:([^/]+)/g;
    const matches = pathname.match(pattern);
    if (matches) {
        matches.forEach(match => {
            if (match.startsWith('/search:')) {
                searchQueryValue = match.substring(8).replace(/%20/g, ' ');
            }
        });
    }

    const parts = pathname.startsWith('/city') && pathname.split('/');
    const cityIndex = parts && parts.indexOf('city');
    const cityName = cityIndex && `${parts[cityIndex + 1]}, ${parts[cityIndex + 2]}`;
    const regex = /\/zipcode\/(\d+)/;

    const zipcodeMatch = regex.exec(pathname);
    const zipcode = zipcodeMatch ? zipcodeMatch[1] : null;

    useEffect(() => {

        const storedSearchVal = localStorage.getItem("search");
        if (storedSearchVal) {
            const [searchQuery, zipcodeQuery] = storedSearchVal.split('&zipcode:');
            setSearchVal(searchQuery || '');
            setZipCodeVal(zipcodeQuery || '');
        }
    }, []);

    const formik = useFormik({
        initialValues: {
            zipcode: "",
        },
        onSubmit: (values: UniversalSearchProps, { resetForm }) => {


            if (searchVal && zipCodeVal) {
                // If both searchVal and zipcode are provided
                typeof localStorage !== "undefined" && localStorage.setItem("search", searchVal + '&zipcode:' + zipCodeVal);
                navigate(`/organizations/browse/search:${searchVal}&zipcode:${zipCodeVal}`);
            } else if (zipCodeVal) {
                // Only zipcode provided
                if (!searchVal) {
                    typeof localStorage !== "undefined" && localStorage.removeItem("search");
                }
                navigate(`${locationSlug}/zipcode/${zipCodeVal}`);
            }

            // if (values.zipcode) {
            //     if (!searchVal) {
            //         typeof localStorage !== "undefined" && localStorage.removeItem("search")
            //     }
            //     navigate(`${locationSlug}/zipcode/${values.zipcode}`)
            // } 
            else if (locationSlug) {
                if (!searchVal) {
                    typeof localStorage !== "undefined" && localStorage.removeItem("search")
                }
                navigate(locationSlug)
            } else if (parseInt(zipCodeVal)) {
                if (!searchVal) {
                    typeof localStorage !== "undefined" && localStorage.removeItem("search")
                }
                navigate(`/zipcode/${zipCodeVal}`);
            } else if (searchVal && !locationSlug) {
                typeof localStorage !== "undefined" && localStorage.setItem("search", searchVal)
                navigate(`/organizations/browse/search:` + searchVal);
            }
            else {
                typeof localStorage !== "undefined" && localStorage.removeItem("search")
                navigate(`/organizations/browse`);
            }
            resetForm({});
        },
    });
    const capitalizeWords = (str: string) => {
        return str
            .toLowerCase()
            .split("-")
            .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };
    const formatCityName = (cityState: string) => {
        const parts = cityState.split(", ");
        const city = capitalizeWords(parts[0]); // Capitalize city name
        const state = parts[1].toUpperCase(); // Keep state abbreviation in uppercase
        return `${city}, ${state}`;
    };

    useEffect(() => {
        if (zipcode) {
            setZipCodeVal(zipcode)
        }
        else if (cityName) {
            setSearchVal(formatCityName(cityName))
        }
        else if (searchQueryValue) {
            setSearchVal(searchQueryValue?.split('&')?.[0])
            setZipCodeVal(searchQueryValue?.match(/zipcode:(\d+)/)?.[1] || '')
        }
        else {
            setSearchVal('')
            setZipCodeVal('')
        }

    }, [zipcode, cityName, searchQueryValue])

    useEffect(() => {
        if (location?.state?.resetSearch || location.pathname.startsWith('/city')) {
            setSearchVal('');
            setZipCodeVal('');
        }
    }, [location]);

    useEffect(() => {
        if (location.pathname === '/' && (searchVal || zipcode || formik?.values?.zipcode)) {

            setSearchVal('');
            setZipCodeVal('')
        }
    }, [location.pathname])


    return (
        <Form className="search-header" onSubmit={formik.handleSubmit}>
            <Button className="btn p-0 m-0 bg-transparent border-0 outline-none" type="submit">
                <InputGroupIcon className='search-icon'>
                    <Image src={Search_icon} width="20px" height="20px" className="search-group-icon" />
                </InputGroupIcon>
            </Button>
            <AutosuggestSearch
                searchValue={searchVal}
                setSearchValue={setSearchVal}
                searchSlug={locationSlug}
                zipCodeVal={zipCodeVal}
                setZipCodeVal={setZipCodeVal}
                setSearchSlug={setLocationSlug}
                placeholder="Org, City & State"
            />
            <FormControl
                type="number"
                placeholder="Zip Code"
                className="mr-sm-2 zip-code-heder get-started-zip zip-code-box"
                maxLength={7}
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                name="zipcode"
                value={zipCodeVal}
                onChange={(e) => setZipCodeVal(e.target.value)} />
            <Button variant="outline-success" type="submit" className="serc">
                search</Button>
        </Form>
    )
}
export default SearchHeader;